import { Fragment } from "react"
import { ApproveAction } from "./ApproveAction"
import { TableNumber } from "components"
import moment from "moment"
import { APPROVAL, convertNumber } from "utils"
import { PaginationState } from "types"
import { ApproveType } from "../types"

type TypeParams = {
  data: ApproveType
  index: number
  refetch: () => void
  pagination: PaginationState
}

export function Item({ data, index, refetch, pagination }: TypeParams) {
  return (
    <Fragment>
      <tr key={index}>
        <td>{TableNumber({ dataLength: pagination.limit , pageCurrent: pagination.page, index: index, limit: pagination.limit, totalData: pagination.total })}</td>
        <td><ApproveAction data={data} refetch={refetch} /></td>
        <td>{data.trx_code}</td>
        <td>{moment(data.transaction_date).format("DD/MM/YYYY")}</td>
        <td>{data.product_name}</td>
        <td className="text-center">{data.qty_build_unit ? convertNumber(data.qty_build_unit).intoNormalAmount : ""}</td>
        <td>{data.mr_unit_name}</td>
        <td>{data.location_name}</td>
        <td className="text-uppercase">
          {Object.keys(APPROVAL).find(key => APPROVAL[key as keyof typeof APPROVAL] === data.approve_status) ?? '-'}
        </td>
        <td>{data.approve_date ? moment(data.approve_date).format("DD/MM/YYYY") : ""}</td>
      </tr>
    </Fragment>
  )
}